module.exports = "/_next/static/images/d6aee20e59b9211326b15cf7beb272c4-rotativo_valor_total.png.webp";